module.exports = __webpack_public_path__ + "img/avatar2.e4c58960.png";